<div class="wrapper">
  <div class="banner">
    <div class="message">
      {{ message }}
    </div>
    <button mat-button class="cancel-button" (click)="onClose()">
      {{ buttonTitle }}
    </button>
  </div>
</div>
